angular
  .module('contabilidad.polizasexternas')
  .service(
    'ContabilidadPolizasexternasCatalogosProyectosNominas',
    ContabilidadPolizasexternasCatalogosProyectosNominas,
  )

ContabilidadPolizasexternasCatalogosProyectosNominas.$inject = ['$http']

function ContabilidadPolizasexternasCatalogosProyectosNominas ($http) {
  this.get = get

  function get (id_proyecto, fecha_inicio, fecha_fin) {
    return $http.get('/api/contabilidad/catalogos/proyectos/nominas', {
      params: {id_proyecto: id_proyecto, fecha_inicio: fecha_inicio, fecha_fin: fecha_fin},
    })
  }
}




// WEBPACK FOOTER //
// ./src/contabilidad/polizasexternas/services/Catalogos/Proyectos/Nominas.js